'use client';
import Slider from '@mui/material/Slider';
import { useTranslate } from '@tolgee/react';
import { useCallback, useState } from 'react';

interface HourSliderProps {
  value?: number;
  onChange?: (value: number) => void;
}

export default function HourSlider({ value = 18, onChange }: HourSliderProps) {
  const { t } = useTranslate();
  const [num, setNum] = useState(value);

  const handleChange = useCallback(() => {
    if (onChange) {
      onChange(num);
    }
  }, [onChange, num]);

  return (
    <Slider
      aria-label="Hour"
      value={num}
      onChange={(e, value) => {
        setNum(value as number);
      }}
      onChangeCommitted={handleChange}
      valueLabelFormat={(value) => `${value} ${t('provider_page.calculator.uptime_slider.unit')}`}
      step={1}
      marks
      min={1}
      max={24}
      sx={{
        color: '#30B28C',
        '& .MuiSlider-valueLabel': {
          backgroundColor: '#30B28C',
          color: '#fff',
        },
      }}
      valueLabelDisplay="on"
    />
  );
}
